import { useNavigate } from "react-router-dom";
import "./blogCard.css";
const BlogCard = ({
  heading,
  description,
  navTo,
}: {
  heading: string;
  description: string[];
  navTo: string;
}) => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (navTo?.startsWith("http")) {
      window.open(navTo, "_blank");
    } else {
      navigate(navTo);
    }
  };
  return (
    <section className="bc-cnt">
      <div className="bc-txt-cnt">
        <p className="bc-heading">{heading} </p>
        {description.map((item, i) => (
          <p style={{ margin: 0 }} key={i}>
            {item}
          </p>
        ))}
      </div>
      <div className="bc-btn-cnt">
        <div onClick={handleNavigation} className="bc-btn">
          Know More
        </div>
      </div>
    </section>
  );
};

export default BlogCard;
